import { render } from "./FeeStructure.vue?vue&type=template&id=40bd4b25&scoped=true"
import script from "./FeeStructure.vue?vue&type=script&lang=js"
export * from "./FeeStructure.vue?vue&type=script&lang=js"

import "./FeeStructure.vue?vue&type=style&index=0&id=40bd4b25&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40bd4b25"]])

export default __exports__